import React, { Component } from 'react';
import './style.less';

export default class Loading extends Component {
  render() {
    return <div className="my-loading">加载中...</div>;
  }
}



// WEBPACK FOOTER //
// ./src/widget/Loading/Loading.js